import type { IToolbarItemConfigTiptap } from 'ricos-types';
import { resolversById } from 'wix-rich-content-toolbars-v3';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';

export default (id, component): IToolbarItemConfigTiptap => {
  return {
    id,
    type: 'custom',
    attributes: {
      visible: resolversById[RESOLVERS_IDS.ALWAYS_VISIBLE],
    },
    commands: {},
    presentation: {
      component,
      dataHook: 'customButton',
    },
  };
};
